import axios from 'axios';

/**
 * /getCountryInfo get api
 * to get the countrieslist for register page */
export async function getCountries(language) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/country_info`, {
      headers: {
        'Accept-Language': language === 'English' ? 'en-US' : 'pt-BR', // the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get country_info java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
* /getUserAreaReponsibleList get api
* to get the area of responsibilties */
export async function GetResponsibilities(language) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/user_area_responsible`, {
      headers: {
        'Accept-Language': language === 'English' ? 'en-US' : 'pt-BR', // the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data.result;
      }
    })
    .catch((err) => {
      console.log('get user_area_responsible java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
* register post api
* to register your account */
export async function postRegister(language, formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/sign_up`, formData, {
      headers: {
        'Accept-Language': language === 'English' ? 'en-US' : 'pt-BR', // the token is a variable which holds the token
      }
    })
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('sign_up java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
* validateUserInfo post api
* to validate User email */
export async function validateUserInfo(formData) {
  let result;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/validate_user_info`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('validate_user_info java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
* checkCompanyName post api
* to check whether same company name exists or not */
export async function checkCompanyName(formData) {
  let result = false;
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/account_availability`, formData)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response.data.status;
      }
    })
    .catch((err) => {
      console.log('validate_user_info java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
* checkCnpj get api
* to check cnpj number valid or not */
export async function checkCnpj(cnpjNumber) {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/check-cnpj/${cnpjNumber}`)
    .then((response) => {
      if (response.status === 200 && response.data) {
        result = response;
      }
    })
    .catch((err) => {
      result = err;
      console.log('validate_user_info java api error', err); // eslint-disable-line no-console
    });
  return result;
}
